import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@src/styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/zh-TW'

Vue.use(ElementUI, { locale });
